import React, { useState } from 'react'
import styles from "./about.module.css";
import Button from '../button';
import decoration_logo from "../../assets/decoration_logo.png";
import Modal from "../modal"
import PopUp from './popUp';

const About = (props) => {

    const goToRegistrationHandler = () => {
        const element = document.getElementById('registration');
        element?.scrollIntoView({
          behavior: 'smooth'
        });
    }

    const [showPopUp, setShowPopUp] = useState(false);

    return (
        <>
            <Modal
                show={showPopUp}
                onClose={()=>{setShowPopUp(false)}}
            >
                <PopUp></PopUp>
            </Modal>
            <div className={styles.container}>
                <img className={styles.decoration_logo} src={decoration_logo} alt='' />
                <h2>Atsipalaiduok ir atgaivink kūną – tavo kelionė į harmoniją prasideda čia!</h2>
                
                <div className={styles.main_text_wrapper}>
                    <h1>Patirk naują save!</h1>
                    <h2>Masažas – tai Jūsų kelias į geresnę savijautą</h2>
                </div>
                
                <div className={styles.controllers}>
                    {/* <Button onClick={()=>{setShowPopUp(true)}}>Nuolaidos</Button>
                    <div style={{ width: "20px", height:"20px" }} /> */}
                    <Button onClick={goToRegistrationHandler}>Rezervacija</Button>
                </div>
            </div>
        </>
    )
}

export default About